import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    CircularProgress,
} from '@material-ui/core';
import { getDraftBody } from '../core/services/import.service';

interface EmailBodyDialogProps {
    open: boolean;
    draftId: string;
    draftTitle: string;
    onClose: () => void;
}

export const EmailBodyDialog: React.FC<EmailBodyDialogProps> = ({
    open,
    draftId,
    draftTitle,
    onClose,
}) => {
    const [body, setBody] = useState('');
    const [format, setFormat] = useState<'html' | 'text'>('text');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!open || !draftId) return;
        setLoading(true);
        setError(null);
        getDraftBody(draftId)
            .then(result => {
                const bodyContent = result?.body || '';
                const bodyFormat = result?.format || 'text';
                setBody(bodyContent);
                setFormat(bodyFormat);
            })
            .catch(() => setError('Failed to load email body.'))
            .finally(() => setLoading(false));
    }, [open, draftId]);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                <Typography style={{ fontWeight: 700, fontSize: '0.95rem' }}>
                    Email: {draftTitle}
                </Typography>
            </DialogTitle>
            <DialogContent>
                {loading ? (
                    <Box style={{ display: 'flex', justifyContent: 'center', padding: '40px 0' }}>
                        <CircularProgress size={28} />
                    </Box>
                ) : error ? (
                    <Typography style={{ color: '#dc2626', fontSize: '0.85rem', padding: '20px 0' }}>
                        {error}
                    </Typography>
                ) : format === 'html' ? (
                    <iframe
                        title="Email body"
                        srcDoc={body}
                        sandbox=""
                        style={{
                            width: '100%',
                            height: 500,
                            border: '1px solid #e2e8f0',
                            borderRadius: 8,
                            backgroundColor: 'white',
                        }}
                    />
                ) : (
                    <Box style={{
                        whiteSpace: 'pre-wrap',
                        fontFamily: 'monospace',
                        fontSize: '0.8rem',
                        color: '#1e293b',
                        backgroundColor: '#f8fafc',
                        border: '1px solid #e2e8f0',
                        borderRadius: 8,
                        padding: 16,
                        maxHeight: 500,
                        overflowY: 'auto',
                    }}>
                        {body || 'No content available.'}
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} style={{ color: '#64748b' }}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};
